module.exports = __webpack_public_path__ + "img/h5img40.80c0a3bd.png";